import { TextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface GKTextFieldProps {
  inputLabel?: string;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    fontSize: 14,
    paddingRight: 8,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[300],
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
  "& .MuiInputLabel-root": {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.grey[600],
  },
  "& .MuiInputLabel-shrink": {
    color: theme.palette.primary.main,
  },
}));

function GKTextField(props: GKTextFieldProps & TextFieldProps) {
  const { inputLabel, placeholder, ...rest } = props;

  return (
    <StyledTextField
      {...rest}
      placeholder={placeholder || inputLabel || "Enter"}
      label={inputLabel}
      fullWidth
    />
  );
}

export default GKTextField;
